/**
 * Camera constraints that depend on the location type.
 *
 * @module searchResultsMap/services/modeCameraConstraints
 */

import {
  DEFAULT_MIN_ZOOM,
  RECTANGULAR_AREA,
  RECTANGULAR_AREA_MIN_ZOOM,
  STATE,
  STATE_MIN_ZOOM,
} from '../constants';

/**
 * @param {string} locationType
 * @returns {number} Minimum map zoom allowed for the location type.
 */
export default function getMinZoomForLocationType(locationType) {
  if (locationType === RECTANGULAR_AREA) {
    return RECTANGULAR_AREA_MIN_ZOOM;
  }

  if (locationType === STATE) {
    return STATE_MIN_ZOOM;
  }

  return DEFAULT_MIN_ZOOM;
}
